import {
  getSchemaText,
  initRawSchema,
  RawSchema,
  toMentionContent,
  toParagraphContent,
  toTextContent,
} from '@principle-theorem/editor';
import { IReffable } from '@principle-theorem/shared';
import {
  INotification,
  INotificationContextRenderer,
} from '@principle-theorem/notifications';
import { toMention } from '../../mention/mention';
import { stafferIsOfRole } from './notification-helpers';
import {
  NotificationType,
  IReopenedTaskResources,
  isTaskResource,
  MentionResourceType,
} from '@principle-theorem/principle-core/interfaces';

export class ReopenedTaskContextRenderer
  implements
    INotificationContextRenderer<
      RawSchema,
      NotificationType,
      IReopenedTaskResources
    >
{
  canRender(notification: INotification): boolean {
    return notification.type === String(NotificationType.ReopenedTask);
  }

  isResource(data: unknown): data is IReopenedTaskResources {
    return isTaskResource(data);
  }

  render(data: IReopenedTaskResources, currentStaffer?: IReffable): RawSchema {
    const isActor: boolean = stafferIsOfRole(currentStaffer, data.interactor);
    const isAssignee: boolean = stafferIsOfRole(
      currentStaffer,
      data.interactor
    );

    const taskMention = toMention(
      { name: getSchemaText(data.task.title), ref: data.task.ref },
      MentionResourceType.Task
    );

    if (isActor || isAssignee) {
      return initRawSchema([
        toParagraphContent([
          toTextContent(`You reopened task `),
          toMentionContent(taskMention),
        ]),
      ]);
    }

    if (data.interactor) {
      const interactorMention = toMention(
        data.interactor,
        MentionResourceType.Staffer
      );
      return initRawSchema([
        toParagraphContent([
          toMentionContent(interactorMention),
          toTextContent(` reopened delegated task `),
          toMentionContent(taskMention),
        ]),
      ]);
    }

    return initRawSchema([
      toParagraphContent([
        toTextContent(`System reopened task `),
        toMentionContent(taskMention),
      ]),
    ]);
  }
}
